import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class FAQPageService {
    constructor(private baseApiFactory: BaseApiFactory) {
    }

    static $inject = ['BaseApiFactory'];

    GetAll(langCode: string, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<any[]>('/api/FAQPage', {language: langCode}, cancelToken);
    }

    Update(value: any) {
        return this.baseApiFactory.put('/api/FAQPage', value);
    }

    Insert(value: any) {
        return this.baseApiFactory.post('/api/FAQPage', value);
    }

    Delete(id) {
        return this.baseApiFactory.delete('/api/FAQPage/' + id);
    }
}

lazyRegister.service('FAQPageService', FAQPageService);